import React from 'react'
import { Grid, Stack, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'

import { AICreditPackages, PricingCards } from '../shadCN/pricing-page'
import PlanComparisonTable from '../shadCN/PlanComparisonTable'

import { setCreditTopOffModalOpen, setCreateTeamModalOpen  } from '@/Redux/appStateSlice'

export default function PlansTabContent(): JSX.Element {
  const dispatch = useDispatch()

  const handleGetCredits = () => {
    dispatch(setCreditTopOffModalOpen(true))
  }

  return (
    <Stack gap="24px">
      <Stack gap="12px">
        <Typography color="#101828" fontSize="20px" fontWeight="600" lineHeight="30px">
          Active Plan
        </Typography>
        <AICreditPackages onGetCredits={handleGetCredits} />
      </Stack>
      <Stack gap="12px">
        <Typography color="#101828" fontSize="20px" fontWeight="600" lineHeight="30px">
          All Plans
        </Typography>
        <Grid container spacing={1}>
          <PricingCards showFeatures={false} />
        </Grid>
      </Stack>
      <PlanComparisonTable
        isCollapsible
        showActions={false}
        onChatToSales={() => {
          console.log('Chat to sales')
        }}
        onGetStarted={() => {
          console.log('Get started')
          dispatch(setCreateTeamModalOpen(true))
        }}
      />
    </Stack>
  )
}
